import { Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';

interface PlatformIcon {
  key: string;
  src: string;
}

@Component({
  selector: 'app-social-platform-icons',
  standalone: true,
  imports: [NgFor, NgIf, AssetVersionPipe],
  templateUrl: './platform-icons.component.html',
  styleUrl: './platform-icons.component.scss',
})
export class SocialPlatformIconsComponent {
  @Input() platforms: string[] = [];
  @Input() iconSize = 16;
  @Input() isVideo = false;

  private readonly PLATFORM_ICONS: PlatformIcon[] = [
    { key: 'facebook', src: 'svg/Facebook.svg' },
    { key: 'instagram', src: 'svg/Instagram.svg' },
    { key: 'messenger', src: 'svg/Messenger.svg' },
    { key: 'threads', src: 'svg/Threads.svg' },
    { key: 'audience_network', src: 'svg/Meta.svg' },
    { key: 'linkedin', src: 'svg/LinkedIn.svg' },
  ];

  protected get visibleIcons(): PlatformIcon[] {
    const present = new Set((this.platforms ?? []).map(p => p.toLowerCase()));
    return this.PLATFORM_ICONS.filter(icon => present.has(icon.key));
  }
}
